var map = {
	"./appcharts": 45562,
	"./appcharts.vue": 45562,
	"./catalogservices": 38604,
	"./catalogservices.vue": 38604,
	"./configurations": 30359,
	"./configurations.vue": 30359,
	"./namespaces": 75257,
	"./namespaces.vue": 75257,
	"./services": 10881,
	"./services.vue": 10881
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66060;
module.exports = webpackAsyncContext;